// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"
import "../stylesheets/application"

require("custom/select2.min")

require('jquery')
require('cocoon-js')

// import 'select2-full'
// import 'select2'
// import 'select2/dist/css/select2.css'

import ApexCharts from 'apexcharts'
window.ApexCharts = ApexCharts



Rails.start()
Turbolinks.start()
ActiveStorage.start()

// $(document).on('turbolinks:load', function(){
//   console.log('Estamos prontos! Turbo link')
// })

 




